<template>
  <el-form
    label-position="left"
    ref="form"
    :model="form"
    :disabled="disabledForm"
    :rules="rules"
    size="mini">

    <!-- <el-form-item label-width="150px" label="Paid Date *" prop="paidDate">
      <el-date-picker
        style="width: 100%; max-width: 155px;"
        v-model="form.paidDate"
        :clearable='false'
        format="d MMM yy"
        value-format="MM-dd-yyyy"
        type="date"
        placeholder="Select Date">
      </el-date-picker>
    </el-form-item> -->

    <el-form-item class="label-without-start" label-width="150px" label="Payment Method *" prop="paymentMethodId">
      <el-select
        no-data-text="no date"
        placeholder="Select Payment Method"
        class="select"
        @change="changePaymentMethod"
        v-model="form.paymentMethodId">
        <el-option
          v-for="item in paymentMethodList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="label-without-start" label-width="150px" label="Payment Account *" prop="depositAccountId">
      <el-select
        no-data-text="no date"
        placeholder="Select Payment Account"
        class="select"
        :disabled="!form.paymentMethodId"
        v-model="form.depositAccountId">
        <el-option
          v-for="item in depositAccountList"
          :key="item.id"
          :disabled="!item.active"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label-width="150px" label="Amount Paid" prop="amountPaid">
      <money style="width: auto;" v-model="form.amountPaid" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-bind="money" @change.native="$emit('calculateResults')"></money>
    </el-form-item>

    <el-form-item label-width="150px" label="Cheque / Ref #" prop="chequeRefNo">
      <el-input placeholder="Cheque Vaucher/Ref #" v-model="form.chequeRefNo" style="width: 100%; max-width: 155px;">
      </el-input>
    </el-form-item>

  </el-form>
</template>

<script>
import { Money } from 'v-money'

export default {
  name: "SinglePaymentMethodCD",
  components: {
    Money
  },
  data() {
    var checkAmountPaid = (rule, value, callback) => {
      if (+value <= 0) {
        return callback(new Error('Please input the field'));
      } else callback();
    }
    return {
      form: {
        // paidDate: null,
        paymentMethodId: null,
        depositAccountId: null,
        chequeRefNo: null,
        // receivedBy: null,
        amountPaid: 0
      },
      rules: {
        paidDate: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        paymentMethodId: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        depositAccountId: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        amountPaid: [{
          validator: checkAmountPaid,
          trigger: 'change'
        }],
        // receivedBy: [{
        //   required: true,
        //   message: this.$i18n.t('modal_settings_fieldIsRequired'),
        //   trigger: 'change'
        // }],
      },
      depositAccountList: [],
      money: {
        precision: 2,
        decimal: '.',
        thousands: ','
      },
    }
  },
  props: {
    paymentMethodList: {
      type: Array,
      default: () => ([])
    },
    disabledForm: {
      type:Boolean,
      default: false
    }
    // paidByList: {
    //   type: Array,
    //   default: () => ([])
    // }
  },
  // computed: {
  //   paidByListChanged() {
  //     return this.paidByList.filter(val => val.isChequeReceipts)
  //   }
  // },
  methods: {
    changePaymentMethod() {
      const pm = this.paymentMethodList.find(item => item.id === this.form.paymentMethodId)
      console.log('pm', pm)
      if (pm) {
        this.depositAccountList = pm.accounts
        this.form.depositAccountId = null
      } else {
        this.depositAccountList = []
        this.form.depositAccountId = null
      }
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          console.log('======', valid)
          resolve(valid)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input {
  width: 100%;
}

// /deep/ .el-date-editor {
//   width: 150px !important;
// }
/deep/.label-without-start {
  :before {
    display: none;
  }
}
/deep/.el-form-item__label:before {
  display: none;
}
</style>